<template>
  <!-- isDepositPaid -->
  <!-- https://filesouthcdn.nxin.com/nxsc_166381135896307018856694597427.png?imageView2/1/w/20/h/20 -->
  <div class="shop">
    <div class="shop_top">
      <div class="clear shop_search">
        <div class="float-left search_main relative">
          <i class="f16_rem iconfont icon-search"></i>
          <input
            type="text"
            v-model="goodsParams.searchText"
            placeholder="输入货品名称"
            @click="jumpSearchShopPage"
          />
        </div>
        <!--eslint-disable-next-line-->
        <van-popover
          class="float-right white search_popover"
          placement="bottom-end"
          v-if="actions.length > 0"
          v-model:show="showPopover"
          :actions="actions"
          @select="getNavigateGoods"
        >
          <template #reference>
            <div @click="showPopover = !showPopover">
              <!--<i class="f18_rem iconfont icon-dh"></i>-->
              <van-icon name="apps-o" size="20" />
              <p>导航</p>
            </div>
          </template>
        </van-popover>
      </div>
      <div class="shop_info clear">
        <img class="float-left" v-if="detail.face" :src="`${detail.face}?imageslim`" alt="" />
        <img
          class="float-left"
          v-else
          src="https://filesouthcdn.nxin.com/nxsc_1498667349766037509690473475377.png?imageView2/1/w/120/h/120"
          alt=""
        />
        <div class="float-left w240" @click="toShopDetail">
          <p class="white">
            <span class="mar10_r f14_rem max_w130 inlineblock ellipsis">{{ detail.name }}</span>
            <!--eslint-disable-next-line-->
            <van-rate
              class="shop_star"
              readonly
              v-model="detail.shopLevel"
              :size="10"
              :gutter="3"
              color="#fff"
              void-color="rgba(255,255,255,0.5)"
              void-icon="star"
            />
          </p>
          <div class="box5"></div>
          <div>
            <span class="shop_info_label f10_rem mar10_r" v-if="detail.isnxyy === 1">运营中心</span>
            <span class="shop_info_label f10_rem mar10_r" v-if="detail.isnxyy === 2"
              >运营中心试运营</span
            >
            <span class="shop_info_label f10_rem mar10_r" v-if="detail.isFactoryDirect === 2"
              >厂家品牌店</span
            >
            <span class="shop_info_label f10_rem mar10_r" v-if="detail.isCoreEnterprise === 1"
              >企业会员</span
            >
            <span class="shop_info_label f10_rem mar10_r" v-if="detail.isDealership === 1"
              >经销店</span
            >
            <span class="shop_info_label f10_rem mar10_r" v-if="detail.isNongxinStation === 1"
              >农信小站</span
            >
            <span class="shop_info_label f10_rem mar10_r" v-if="detail.isOptimization === 1"
              >农信优选</span
            >
            <img
              v-if="detail.isDepositPaid"
              class="depositPaid"
              src="https://nfs.t.nxin.com/776b3f6832714ce2b7e6c0f70195338d.png?imageView2/1/w/50/h/50"
              alt=""
            />
          </div>
        </div>
        <div
          class="float-right shop_info_label shop_info_attention red f12_rem"
          @click="shopCollect"
        >
          <i v-if="this.isShopCollect" class="f16_rem iconfont icon-shoucang1"></i>
          <i v-if="!this.isShopCollect" class="f16_rem iconfont icon-shoucang2"></i>
          <span>收藏</span>
          <!--<i v-if="!this.isShopCollect" class="f16_rem iconfont icon-shoucang2"></i>
          <span v-if="this.isShopCollect">已关注</span>
          <span v-else>关注</span>-->
        </div>
      </div>
    </div>
    <div class="shop_tab pad60-b">
      <!--<div class="shop_tab_classify white" :class="{isFixed:isFixed}">
        <ul>
          <li
            :class="{tab_classify_active:tabIndex === index}"
            v-for="(item, index) in shopTab"
            :key="index"
            @click="switchTab(index)">
            {{item}}
          </li>
        </ul>
      </div>-->
      <!--:class="{pad45_t:isFixed}"-->
      <div v-if="tabIndex === 0">
        <van-swipe class="shop_swipe" :autoplay="3000" indicator-color="white">
          <template v-if="detail.imgs && detail.imgs.length > 0">
            <van-swipe-item v-for="(img, index) in detail.imgs" :key="index">
              <img :src="`${img.coverUrl}?imageslim`" alt="" />
            </van-swipe-item>
          </template>
          <template v-else>
            <van-swipe-item>
              <img
                src="https://filesouthcdn.nxin.com/nxsc_1671677249541004656633779877728.JPEG"
                alt=""
              />
            </van-swipe-item>
          </template>
        </van-swipe>
        <div class="shop_coupon">
          <ul class="clear">
            <template v-for="(coupRegular, index) in detail.coupRegularResList">
              <li
                class="clear"
                v-if="
                  coupRegular.userFetchNum < coupRegular.fetchLimit && coupRegular.surplusNum > 0
                "
                :key="index"
              >
                <div class="f10_rem shop_coupon_category">{{ coupRegular.typeName }}</div>
                <div class="t_center shop_coupon_main">
                  <p class="f18_rem">{{ coupRegular.regVal }}</p>
                  <div class="box5"></div>
                  <p class="f12_rem">满{{ coupRegular.regKey }}元可用</p>
                </div>
                <div class="shop_coupon_get" @click="couponGet(coupRegular)">领取</div>
              </li>
              <li class="clear coupon_li_get" v-else-if="coupRegular.userFetchNum > 0" :key="index">
                <div class="f10_rem shop_coupon_category">{{ coupRegular.typeName }}</div>
                <div class="t_center shop_coupon_main">
                  <p class="f18_rem">{{ coupRegular.regVal }}</p>
                  <div class="box5"></div>
                  <p class="f12_rem">满{{ coupRegular.regKey }}元可用</p>
                </div>
                <div class="shop_coupon_get" @click="getCouponTo(coupRegular)">去使用</div>
              </li>
            </template>
          </ul>
        </div>
        <div class="padd_15 border_radius_10 b_white mar15_b" v-if="goodsList.length > 0">
          <p class="f15_rem gray_2 lin_15">最新上架</p>
          <div class="box25"></div>
          <goodTemplate1 :goodsList="goodsList" @getCountCart="getCountCart" />
        </div>
        <div class="padd_15 border_radius_10 b_white mar15_b" v-if="promotionGoods.length > 0">
          <p class="f15_rem gray_2 lin_15">促销推荐</p>
          <div class="box25"></div>
          <goodTemplate1 :goodsList="promotionGoods" @getCountCart="getCountCart" />
        </div>
        <div class="padd_15 border_radius_10 b_white mar15_b" @click="jumpIntroduce">
          <p class="f15_rem gray_2 lin_15">店铺介绍</p>
          <div class="box25"></div>
          <p class="f14_rem gray_2 lin_15">{{ detail.name }}</p>
          <div class="box12"></div>
          <p class="f12_rem gray_9 lin_15">
            在售货品数 <span>{{ detail.onSell }}</span>
          </p>
          <div class="box12"></div>
          <p class="f12_rem gray_2 lin_15 letter_1" v-if="detail.shopIntroduce">
            {{ detail.shopIntroduce }}
          </p>
          <p class="f12_rem gray_2 lin_15 letter_1" v-else-if="detail.intro">{{ detail.intro }}</p>
          <p class="f12_rem gray_2 lin_15 letter_1" v-else>
            欢迎进入{{ detail.name }}，本店位于{{ detail.areaName }}，主要经营{{
              detail.businessScope
            }}等业务。本店秉承“诚信经营、顾客至上”的经营理念，欢迎新老客户进行选购，同时会不定期开展各种优惠活动，敬请关注。
          </p>
        </div>
      </div>
      <!--:class="{pad45_t:isFixed}"-->
      <div v-if="tabIndex === 1">
        <van-tabs @click="getCategoryGoods" v-model="active">
          <van-tab
            v-for="item in classifyList"
            :title="item.text"
            :name="item.shopDecorateId"
            :key="item.text"
          >
            <van-list
              :loading="allGoodLoaing"
              :finished="allGoodFinished"
              :offset="65"
              finished-text="没有更多了"
              @load="onLoad"
              class="clear"
              v-if="allLoading"
            >
              <goodTemplate1 :goodsList="allGoodsList" @getCountCart="getCountCart" />
            </van-list>
          </van-tab>
        </van-tabs>
      </div>
      <div class="footer_iphone"></div>
    </div>
    <div class="shop_nav">
      <ul>
        <li @click="switchTab(0)" :class="{ red: tabIndex === 0 }">
          <van-icon name="wap-home-o" size="20" />
          <p>首页</p>
        </li>
        <li @click="switchTab(1)" :class="{ red: tabIndex === 1 }">
          <van-icon name="bag-o" size="20" />
          <p>货品</p>
        </li>
        <li @click="toCart">
          <van-icon name="cart-o" size="20" />
          <span v-if="countCart > 0" class="mui-badge">{{
            countCart > 99 ? "99+" : countCart
          }}</span>
          <p>进货车</p>
        </li>
        <li @click="zixun">
          <van-icon name="chat-o" size="20" />
          <p>咨询</p>
        </li>
      </ul>
      <div class="footer_iphone"></div>
    </div>
  </div>
</template>

<script>
import { Toast } from "vant";
import { mapState } from "vuex";
import goodTemplate1 from "@/components/goodList/template1";
import common from "../../assets/js/common";
// import goodTemplate2 from '@/components/goodList/template2';

export default {
  components: {
    goodTemplate1
    // goodTemplate2,
  },

  data() {
    return {
      active: "allSelect",
      shopStar: 3,
      isFixed: false,
      shopTab: ["店铺首页", "全部货品"],
      tabIndex: 1,
      showClassifyPopover: false,
      showPopover: false,
      actions: [],
      classifyList: [],
      shopId: "",
      detail: {
        coupRegularResList: []
      },
      isShare: false, // 分享
      couponName: "", // 券名称
      isShopCollect: false,
      current: 0,
      imgSize: 1,
      countNum: 1,
      countCart: 0, // 购物车数量
      goodsParams: {}, // 商品请求参数
      allGoodsList: [],
      goodsList: [], // 最新上架
      promotionGoods: [], // 促销推荐
      promotionMap: {
        DIRECT_SELLING: "直降",
        DISCOUNT: "折扣",
        BUY_GIFTS: "买赠",
        GROUP_PURCHASE: "集采"
      },
      allGoodLoaing: false,
      allGoodFinished: false,
      allLoading: false
    };
  },
  /* mounted() {
    window.addEventListener('scroll', this.getScroll);
  }, */
  /* destroyed() {
    window.removeEventListener('scroll', this.getScroll);
  }, */
  computed: mapState({
    userInfo: state => state.app.userInfo
  }),
  created() {
    this.shopId = this.$route.params.shopId;
    if (!common.isMobile()) {
      window.location.href = `${process.env.VUE_APP_APP}shopInfo/shopInfoList.do?shopId=${
        this.shopId
      }`;
      return;
    }
    this.switchTab(this.tabIndex, this.$route.query);
    this.getShopZXInfoByShopId();
    this.getCountCart();
    this.getCategoryList();
  },
  mounted() {},
  beforeRouteLeave(to, from, next) {
    this.scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
    next();
  },
  // 进入该页面时，用之前保存的滚动位置赋值
  beforeRouteEnter(to, from, next) {
    next(vm => {
      console.log("scrollTop", vm.scrollTop);
      document.body.scrollTop = vm.scrollTop;
    });
  },
  methods: {
    // 全部货品加载
    onLoad() {
      if (this.allGoodsList.length) {
        this.allGoodLoaing = true;
        this.clickToMore();
      }
    },
    getScroll() {
      const scrollTop =
        window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
      if (scrollTop >= 90) {
        this.isFixed = true;
      } else {
        this.isFixed = false;
      }
    },
    initGoodsParams() {
      // 处理参数
      const { query } = this.$route;
      this.goodsParams = {
        shopId: this.shopId,
        searchText: "",
        isPromotionOrSelf: query.isPromotionOrSelf,
        shopDecorateId:
          !query.shopDecorateId || query.shopDecorateId === "allSelect" ? "" : query.shopDecorateId,
        linkIds: query.linkIds,
        linkId: query.linkId,
        pageSize: 6,
        pageNum: 1
      };
    },
    getShopDetail(params) {
      Toast.loading({
        mask: true,
        message: "加载中...",
        duration: 0
      });
      const param = {
        shopId: this.shopId,
        fromShopId: params.fromShopId,
        linkIds: params.linkIds
      };
      this.$store
        .dispatch("shop/shopDetails/detail", this.$qs.stringify(param))
        .then(data => {
          this.detail = data.data || {};
          if (data.code === "404004") {
            Toast("店铺不存在");
            return;
          }
          if (this.detail.coupRegularResList && this.detail.coupRegularResList.length > 0) {
            // 优惠券
            this.detail.coupRegularResList.forEach(coupRegular => {
              this.$set(coupRegular, "typeName", this.getCouponTypeName(coupRegular));
            });
          }
          this.isShopCollect = this.detail.favoriteShop;
          this.initData();
        })
        .catch(() => {
          Toast.clear();
        });
    },
    getCouponTypeName(coupon) {
      let couponTypeName = "";
      if (coupon.busId.indexOf("SHOP#FFFF") !== -1) {
        if (coupon.regVal === coupon.regKey) {
          couponTypeName = "全品类(特例商品除外)";
        } else {
          couponTypeName = "全平台通用优惠券";
        }
      } else if (coupon.applyRangeExplain !== "") {
        couponTypeName = coupon.applyRangeExplain;
      } else if (coupon.busType === "SHOP") {
        couponTypeName = "全店通用";
      } else if (coupon.busType === "GOODS") {
        couponTypeName = "店铺指定商品可用";
      } else if (coupon.busType === "CATE") {
        couponTypeName = "指定分类商品可用";
      }
      return couponTypeName;
    },

    // 导航
    getShopZXInfoByShopId() {
      const param = {
        shopId: this.shopId,
        functionType: 1
      };
      this.$store
        .dispatch("shop/shopDetails/getShopZXInfoByShopId", this.$qs.stringify(param))
        .then(data => {
          const newData = data.decEntities || [];
          newData.forEach(item => {
            item.text = item.name;
          });
          this.actions = newData;
        });
    },
    // 分类
    getCategoryList() {
      const param = {
        shopId: this.shopId,
        functionType: 2
      };
      this.$store
        .dispatch("shop/shopDetails/categoryList", this.$qs.stringify(param))
        .then(data => {
          const newData = data || [];
          newData.forEach(item => {
            item.text = item.name;
          });
          newData.unshift({
            shopDecorateId: "othorShopGoods",
            text: "代销商品"
          });
          newData.unshift({
            shopDecorateId: "allSelect",
            text: "全部货品"
          });
          this.classifyList = newData;
          console.info(this.classifyList);
        });
    },
    // 分类
    getShopIndex() {
      const param = {
        shopId: this.shopId
      };
      this.$store.dispatch("shop/shopDetails/shopIndex", this.$qs.stringify(param)).then(data => {
        Toast.clear();
        if (data) {
          this.goodsList = this.goodsFieldHandle(data.goodsList);
          this.promotionGoods = this.goodsFieldHandle(data.promotionGoods);
        }
      });
    },
    // 根据分类查询货品
    getCategoryGoods(shopDecorateId) {
      this.initGoodsParams();
      this.goodsParams.shopDecorateId = shopDecorateId;
      this.shopGoodsNew();
    },
    // 根据导航查询商品
    getNavigateGoods(item) {
      this.initGoodsParams();
      if (item.linkType === 1) {
        if (!item.linkId) {
          Toast("货品类型ID为空！");
          return;
        }
        if (this.detail.businessType === "5") {
          window.location.href = `${process.env.VUE_APP_APP}mob/egg/goods/eggDetail/${item.linkId}`;
        } else {
          window.location.href = `${process.env.VUE_APP_APP}mob/goods/detail/${item.linkId}`;
        }
      }
      if (item.linkType === 2) {
        if (!item.linkId) {
          Toast("货品类型ID为空！");
          return;
        }
        this.active = "allSelect";
        this.goodsParams.linkId = item.linkId;
        this.shopGoodsNew();
      }
      if (item.linkType === 3) {
        if (!item.linkId) {
          Toast("自定义页面异常！");
          return;
        }
        window.location.href = `${
          process.env.VUE_APP_APP
        }shopInfo/toCustomPageView?shopDecorateId=${item.linkId}&shopId=${this.shopId}&linkId=${
          item.linkId
        }`;
      }
      if (item.linkType === 4) {
        if (!item.linkId) {
          Toast("自定义链接异常！");
          return;
        }
        if (item.linkId.indexOf("http") >= 0) {
          window.location.href = item.linkId;
        } else {
          if (item.linkId.indexOf("sc.nxin.com") >= 0) {
            window.location.href = `https://${item.linkId}`;
          } else {
            window.location.href = `http://${item.linkId}`;
          }
        }
      }
      if (item.linkType === 5) {
        if (!item.linkId) {
          Toast("自定义链接异常！");
          return;
        }
        window.location.href = item.linkId;
      }
      // 链接多个商品  id的值为 商品id集合 格式为商品id逗号分隔的字符串 id，id，id.....
      if (item.linkType === 6) {
        if (!item.linkId) {
          Toast("货品ID为空！");
          return;
        }
        this.active = "allSelect";
        this.goodsParams.linkIds = item.linkId;
        this.shopGoodsNew();
      }
    },
    // 加载更多
    clickToMore() {
      this.goodsParams.pageNum = this.goodsParams.pageNum + 1;
      this.shopGoodsNew(1);
    },
    // 查询货品
    shopGoodsNew(type) {
      if (type !== 1) {
        Toast.loading({
          mask: true,
          message: "加载中...",
          duration: 0
        });
        this.allLoading = false;
      }
      this.tabIndex = 1;
      this.$store
        .dispatch("shop/shopDetails/shopGoodsNew", this.$qs.stringify(this.goodsParams))
        .then(data => {
          Toast.clear();
          const list = this.goodsFieldHandle(data.list);
          // 加载更多
          if (type === 1) {
            this.allGoodsList = [...this.allGoodsList, ...list];
            this.allGoodLoaing = false;
            if (!list.length) {
              this.allGoodFinished = true;
            }
            return;
          }
          this.allLoading = true;
          this.allGoodFinished = false;
          if (!data.list.length) {
            this.allGoodFinished = true;
          }
          this.allGoodsList = this.goodsFieldHandle(data.list);
        })
        .catch(() => {
          Toast.clear();
        });
    },
    // 店铺收藏 取消收藏
    shopCollect() {
      if (!common.isLogin(this.userInfo.id)) {
        return;
      }
      if (!this.isShopCollect) {
        const favoriteArr = [
          {
            type: 2,
            resId: this.shopId
          }
        ];
        this.addFavorite(favoriteArr);
      } else {
        const favorite = {
          type: 2,
          resId: this.shopId
        };
        this.delFavorite(favorite);
      }
    },
    addFavorite(favorite) {
      this.$store
        .dispatch("member/member/addFavorite", {
          json: encodeURIComponent(JSON.stringify(favorite))
        })
        .then(() => {
          this.isShopCollect = true;
          Toast({
            message: "收藏成功",
            icon: "star-o"
          });
        });
    },
    delFavorite(favorite) {
      this.$store
        .dispatch("member/member/delRecordFavorite", this.$qs.stringify(favorite))
        .then(() => {
          this.isShopCollect = false;
          Toast({
            message: "取消收藏",
            icon: "star-o"
          });
        });
    },
    getCountCart() {
      this.$store.dispatch("member/member/getCountCart", this.$qs.stringify({})).then(data => {
        this.countCart = data || 0;
      });
    },
    // 点击咨询
    zixun() {
      if (isInNxinApp()) {
        if (!common.isLogin(this.userInfo.id)) {
          return;
        }
        const param = { shopId: this.shopId };
        this.$store.dispatch("shop/shopDetails/getBoIdByShopId", { params: param }).then(data => {
          znt.openContactChat({ archiveId: data });
        });
      } else {
        window.location.href = "https://znt.nxin.com";
      }
    },
    initData() {
      // 判断是否是在智农通内
      if (isInNxinApp()) {
        this.isShare = true;
      } else {
        this.isShare = false;
      }
    },
    // 点击分享
    share() {
      // 没有拼接参数 ?后接参数
      let link = `${window.location.href}?forward_id=${this.detail.businessType.trim()}}`;
      if (window.location.href.indexOf("=") > -1) {
        // 已经拼接参数 不能用?
        link = `${window.location.href}&forward_id=${this.detail.businessType.trim()}`;
      }
      let src =
        "https://filesouthcdn.nxin.com/nxsc_1498667349766037509690473475377.png?imageView2/1/w/120/h/120";
      if (this.detail.face) {
        src = `${this.detail.face}?imageslim`;
      }
      znt.openSharePanel({
        title: this.detail.name,
        desc: this.detail.businessScope,
        link: encodeURI(link),
        imgUrl: src
      });
    },
    toCart() {
      if (!common.isLogin(this.userInfo.id)) {
        return;
      }
      // window.location.href = '/vm/cart';
      let retUrl = "/mob/cart/cartInfoList.do";
      const typeId = common.getCookie("typeId");
      if (typeId) {
        retUrl = `${retUrl}?typeId=${typeId}`;
      }
      window.location.href = retUrl;
    },
    // 跳转店铺介绍
    jumpIntroduce() {
      window.location.href = `${
        process.env.VUE_APP_APP
      }mob/shop/JumpshopDetailIntroduction?shopId=${this.shopId}`;
    },
    // 跳转店铺页
    toShopDetail() {
      window.location.href = `${process.env.VUE_APP_APP}mob/shop/toShopDetails?shopId=${
        this.shopId
      }`;
    },
    // 跳转商品详情
    jumpSearchShopPage() {
      window.location.href = `${process.env.VUE_APP_APP}mob/goods/searchPage.do?isShop=1&shopId=${
        this.shopId
      }`;
    },
    getCouponTo(coupon) {
      const { busType, subBusId, busId, cpChannel, cpId } = coupon;
      const couPonStr = `满${coupon.regKey}减${coupon.regVal}`;
      // 支持全店铺
      if (subBusId.indexOf("SHOP#FFFF") !== -1) {
        window.location.href = `${
          process.env.VUE_APP_APP
        }mob/goods/goodsList.do?shopIds=''&couPonStr=${couPonStr}`;
        return;
      }
      if (busType === "SHOP") {
        if (subBusId.split(",").length > 1) {
          window.location.href = `${
            process.env.VUE_APP_APP
          }mob/goods/goodsList.do?shopIds=${subBusId}&couPonStr=${couPonStr}`;
        } else {
          window.location.href = `${
            process.env.VUE_APP_APP
          }vm/shop/${subBusId}?couPonStr=${couPonStr}`;
        }
      } else if (busType === "GOODS") {
        if (cpChannel === "PLATFORM") {
          window.location.href = `${
            process.env.VUE_APP_APP
          }mob/goods/goodsList.do?platformCouponId=${cpId}&couPonStr=${couPonStr}`;
          return;
        }
        if (subBusId.split(",").length > 1) {
          window.location.href = `${
            process.env.VUE_APP_APP
          }mob/shop/shopDetail/${busId}?linkIds=${subBusId}&couPonStr=${couPonStr}`;
        } else {
          window.location.href = `${process.env.VUE_APP_APP}vm/goodDetails/${subBusId}`;
        }
      } else if (busType === "CATE") {
        window.location.href = `${
          process.env.VUE_APP_APP
        }mob/goods/goodsList.do?linkIds=${subBusId}&shopId=${busId}&couPonStr=${couPonStr}`;
      }
    },
    couponGet(coupon) {
      if (!common.isLogin(this.userInfo.id)) {
        return;
      }
      const params = {
        // boId: this.userInfo.id,
        regCode: coupon.regCode,
        busId: coupon.busId,
        regVal: coupon.regVal
      };
      this.$store
        .dispatch("goodDetails/goodDetails/getShopCoupon", this.$qs.stringify(params))
        .then(data => {
          if (data.msg) {
            Toast(data.msg);
          }
          if (data.code === "0") {
            this.$set(coupon, "userFetchNum", 1);
          }
        });
    },
    switchTab(index, query) {
      console.log("index===", index);
      if (index == 0) {
        window.location.href = `${process.env.VUE_APP_taaspublic}?shopId=${this.shopId}`;
      }
      this.initGoodsParams();
      this.tabIndex = index;
      if (query) {
        this.$set(this.goodsParams, "searchText", query.searchText ? query.searchText : "");
        if (
          query.searchText ||
          query.shopDecorateId ||
          query.linkIds ||
          query.linkId ||
          query.couPonStr
        ) {
          this.tabIndex = 1;
        }
      }
      this.getShopDetail(this.$route.query);
      if (this.tabIndex === 0) {
        this.getShopIndex();
      }
      if (this.tabIndex === 1) {
        this.shopGoodsNew();
      }
    },
    goodsFieldHandle(goodsList) {
      const newGoodsList = [];
      if (goodsList && goodsList.length > 0) {
        goodsList.forEach(goods => {
          newGoodsList.push({
            goodsId: goods.goodsId,
            picUrl: goods.picUrl ? goods.picUrl : goods.imgUrl,
            isSelfOperated: goods.isSelfOperated,
            isOptimization: goods.isOptimization,
            name: goods.name,
            sellFactPrice: goods.promotionPrice,
            sellPrice: goods.marketPriceStr ? goods.marketPriceStr : goods.price,
            isVip: goods.isVip,
            coupRegularResList: goods.coupRegularResList,
            promotionType: goods.promotionType,
            promotionTypeCN: goods.promotionType ? this.promotionMap[goods.promotionType] : "",
            isOthersGoodsReceipt: goods.shopDtlEntity
              ? goods.shopDtlEntity.isOthersGoodsReceipt
              : 0,
            isPrescription: goods.isPrescription,
            shopName: goods.shopName,
            // shopIds: goods.shopIdStr ? goods.shopIdStr : goods.shopIds,
            shopIds: this.shopId,
            goodsPriceMemberLevel: goods.goodsPriceMemberLevel
          });
        });
      }
      return newGoodsList;
    }
  }
};
</script>

<style lang="scss" scoped>
@import "./style.scss";
</style>
